import {
  Flex,
  FloatingBall,
  List,
  PullRefresh,
  Search,
  Tabs,
  Toast,
} from 'react-vant';
import { useRef, useState } from 'react';
import { Plus } from '@react-vant/icons';
import './index.less';
import { rendAndSaleEnum } from '../config';
import NoData from '@/components/NoData';
import HouseRendAndSaleListContainer from '@/components/HouseRendAndSaleListContainer';
import { history, useModel } from '@umijs/max';
// import { useSafeState } from 'ahooks';
import { getWechatRentPage } from '@/service/rentHouse';
import SearchPopus from './components/SearchPopus';
import { useSafeState } from 'ahooks';

const HouseRentAndSale = () => {
  const [finished, setFinished] = useState<boolean>(false);
  const activeKey = useRef<string>('SALE');
  const [saleDataList, setSaleDataList] = useState<any>([]);
  const [selectVisible, setSelectVisible] = useSafeState<boolean>(false);



  const { defaultRoom, ownerInformation } = useModel(
    'useDefaultRoom',
    (model) => ({
      defaultRoom: model.defaultRoom,
      ownerInformation: model.ownerInformation
    }),
  );

  const pageNum  = useRef(1);
  const searchValueData  = useRef({});
 
  const onLoadRefresh = async (isRefresh: boolean | undefined) => {
    setSaleDataList([])
    console.log(99, searchValueData.current)
    const types =  activeKey.current === 'SALE' ? '1,2': activeKey.current === 'RENT_REQUEST' ? '3,4': undefined
    const createBy = activeKey.current === 'MINE' ? ownerInformation?.nickName : ''
    
    const data = await getWechatRentPage({ current: pageNum.current, pageSize: 10, status: '1', communityId: defaultRoom?.communityId, types, createBy, ...searchValueData.current })
    const listData: any =  [...saleDataList, ...data.rows]
    if (isRefresh || pageNum.current === 1) {
      setSaleDataList(data.rows); 
    } else {
      setSaleDataList(listData);
    }
 
    
    if (data.rows.length === data.total || data.rows.length < 10 || !data.rows.length || data.total === 0) { // 如果没有更多数据，则结束加载状态并设置finished为true
      setFinished(true);
    } else {
      pageNum.current = pageNum.current + 1
      setFinished(false); // 仍有数据可加载，保持为false
    }
  }

  const onRefresh = async () => {
    pageNum.current = 1
    setFinished(true)
    setSaleDataList([])
    onLoadRefresh(true)
  }

  const publish = () => {
    // Toast.success('发布成功');
    console.log(activeKey, 'activeKey');
    if (activeKey.current === 'SALE') {
      history.push('/publishSent');
    } else {
      history.push('/publishWantSale');
    }
  };

  const onSuccessSearch = (values: any) => {
    
    setSelectVisible(false)
    searchValueData.current = values
    onRefresh()
  }



  const tabChange = (key: any) => {
    console.log(66, key)
    activeKey.current = key
    onRefresh()
  };

  return (
    <div>
      <Search
        onClickInput={(v) => setSelectVisible(true)}
      />
      <SearchPopus
        visible={selectVisible}
        onSuccessSearch={onSuccessSearch}
        onClose={() => setSelectVisible(false)}
      />
      
      <Tabs sticky active={activeKey.current} onChange={tabChange}>
        <Tabs.TabPane title={'房屋租售'} name={'SALE'}>
         
            <PullRefresh onRefresh={onRefresh}>
              <List finished={finished} onLoad={onLoadRefresh}>
              {saleDataList.length ? <>
                {saleDataList.map((item: any) => (
                  <HouseRendAndSaleListContainer
                    rendAndSaleListItem={item}
                    key={item.sequenceNbr}
                    type={rendAndSaleEnum.SALE}
                  />
                ))}
              </> : (
                <NoData />
              )}
              </List>
            </PullRefresh>
          
        </Tabs.TabPane>
        <Tabs.TabPane title={'求租求购'} name={'RENT_REQUEST'}>
          
            <PullRefresh onRefresh={onRefresh}>
              <List finished={finished} onLoad={onLoadRefresh}>
              {saleDataList.length ? <>
                {saleDataList.map((item: any) => (
                  <HouseRendAndSaleListContainer
                    rendAndSaleListItem={item}
                    key={item.sequenceNbr}
                    type={rendAndSaleEnum.RENT_REQUEST}
                  />
                ))}
              </> : (
                <NoData />
              )}
              </List>
            </PullRefresh>
         
        </Tabs.TabPane>
        <Tabs.TabPane title={'我的'} name={'MINE'}>
          
            <PullRefresh onRefresh={onRefresh}>
              <List finished={finished} onLoad={onLoadRefresh}>
              {saleDataList.length ? <>
                {saleDataList.map((item: any) => (
                  <HouseRendAndSaleListContainer
                    rendAndSaleListItem={item}
                    key={item.sequenceNbr}
                    type={rendAndSaleEnum.MINE}
                  />
                ))}
              </>: (
                <NoData />
              )}
              </List>
            </PullRefresh>
         
        </Tabs.TabPane>
      </Tabs>
      <FloatingBall
        offset={{
          right: 20,
          bottom: 20,
        }}
        style={{
          '--rv-floating-box-size': '60px',
        }}
        adsorb={{
          // 滚动缩进比例
          indent: 0.5,
          // 近边停靠距离
          distance: 20,
        }}
        className={'floating-btn'}
      >
        <Flex
          onClick={publish}
          align={'center'}
          justify={'center'}
          className={'main-button'}
        >
          <Plus />
        </Flex>
      </FloatingBall>
    </div>
  );
};

export default HouseRentAndSale;
